import { Link } from "react-router-dom";
import TopNav from "../components/TopNav";
import Orbs from "../components/Orbs";
import { Section, Overline } from "../components/Layout";

// Per-environment: staging events is launched from foundry-dev, production
// from foundry. Set at BUILD time (see Dockerfile / render.yaml).
const FOUNDRY_URL = process.env.REACT_APP_FOUNDRY_URL || "https://foundry.venturedock.com";

/**
 * M2: password login is retired. Staff sign in to Foundry (Google SSO) and
 * launch Events Admin from its sidebar — the SSO handoff lands on /sso. This
 * page remains only as the ProtectedRoute redirect target.
 */
export default function Login() {
  return (
    <div className="relative min-h-screen" data-testid="login-page">
      <Orbs />
      <div className="relative z-10">
        <TopNav />
        <Section className="pt-20 pb-24" innerClassName="max-w-md mx-auto">
          <div className="glass-strong rounded-3xl p-8 text-center">
            <Overline>Admin</Overline>
            <h1 className="mt-3 text-3xl font-heading font-medium tracking-tight">Sign in via Foundry</h1>
            <p className="text-muted-foreground text-sm mt-2">
              Events admin uses your VentureDock staff account. Open Foundry and
              choose <span className="text-foreground">Events Admin</span> from the sidebar.
            </p>
            <a href={FOUNDRY_URL} className="btn-primary w-full inline-block mt-8" data-testid="login-foundry-btn">
              Open Foundry
            </a>
            <div className="mt-6 text-sm text-muted-foreground">
              Looking for events? Browse them at{" "}
              <Link to="/events" className="text-primary hover:underline" data-testid="login-events-link">
                venturedock.com/events
              </Link>.
            </div>
          </div>
        </Section>
      </div>
    </div>
  );
}
